import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import { Icon } from '@/components/Icon';
import { LegacyButton } from '@/components/LegacyButton';
import type {
  ContentfulImageWithFocalPointFragment,
  ContentfulPlaceholderFragment,
} from '@/graphql/contentful/api';
import { useRegionProvider } from '@/providers/RegionProvider';

import * as S from './ExploreSection.styles';
import * as M from './messages';
type ExploreSectionProps = {
  warrantyTakingCareOfYourWatch?: ContentfulPlaceholderFragment['warrantyTakingCareOfYourWatch'];
};
export const ExploreSection = ({
  warrantyTakingCareOfYourWatch,
}: ExploreSectionProps) => {
  const { locale } = useRegionProvider();
  return (
    <S.Wrapper>
      <S.GridWrapper>
        {warrantyTakingCareOfYourWatch?.media && (
          <>
            <S.StyledMediaWrapperContainerDeskTop>
              <S.StyledMediaWrapper
                {...(warrantyTakingCareOfYourWatch?.media as ContentfulImageWithFocalPointFragment)}
                mediaWrapperType='WarrantyPlaceholderDeskTop'
                preload={true}
                sizes='(max-width: 600px) 50vw, 20vw'
                useAspectRatio={false}
              />
            </S.StyledMediaWrapperContainerDeskTop>
            <S.StyledMediaWrapperContainerMobile>
              <S.StyledMediaWrapper
                {...(warrantyTakingCareOfYourWatch?.media as ContentfulImageWithFocalPointFragment)}
                mediaWrapperType='WarrantyPlaceholderMobile'
                preload={true}
                sizes='(max-width: 600px) 50vw, 20vw'
                useAspectRatio={true}
              />
            </S.StyledMediaWrapperContainerMobile>
          </>
        )}

        <S.Header data-testid='warrantyExploreHeader'>
          {warrantyTakingCareOfYourWatch?.placeholderWarrantyHeading?.text ??
            M.Header}
        </S.Header>
        {warrantyTakingCareOfYourWatch?.placeholderWarrantyText ? (
          <S.DescriptionTop
            dangerouslySetInnerHTML={{
              __html: documentToHtmlString(
                warrantyTakingCareOfYourWatch.placeholderWarrantyText.json,
              ),
            }}
            data-testid='warrantyExploreDescTop'
          />
        ) : (
          <S.DescriptionTop data-testid='warrantyExploreDescTop'>
            {M.DescriptionTop}
          </S.DescriptionTop>
        )}
        {warrantyTakingCareOfYourWatch?.placeholderWarrantyText2 ? (
          <S.DescriptionBottom
            dangerouslySetInnerHTML={{
              __html: documentToHtmlString(
                warrantyTakingCareOfYourWatch.placeholderWarrantyText2.json,
              ),
            }}
            data-testid='warrantyExploreDescBottom'
          />
        ) : (
          <S.DescriptionBottom data-testid='warrantyExploreDescBottom'>
            {M.DescriptionBottom}
          </S.DescriptionBottom>
        )}
        <S.ExploreLinkWrapper>
          <LegacyButton
            aria-label={getLinkAriaLabel(
              warrantyTakingCareOfYourWatch?.url ?? '/',
              locale.code,
            )}
            data-testid='warrantyExploreLink'
            href={warrantyTakingCareOfYourWatch?.url ?? '/'}
            label={warrantyTakingCareOfYourWatch?.urlText ?? M.Link}
            size='l'
            variant='link'
            width='auto'
          >
            <Icon name='chevronRight' />
          </LegacyButton>
        </S.ExploreLinkWrapper>
      </S.GridWrapper>
    </S.Wrapper>
  );
};
